import {DUFFLOO_MODE, getBackendBaseUrl} from '../config/environment';
import {createBrowserDiagnostics} from '../utils/browserDiagnostics.core';

/**
 * No firebase import here (2026-09-28 review). This module loads on EVERY page
 * (gatsby-browser.js, AppErrorBoundary), and importing utils/firebase started
 * Firebase Auth for every visitor before cookie consent — on mobile and Safari
 * that loads Google's api.js and the auth iframe and writes IndexedDB. Pages
 * that already use auth register the token getter (utils/firebase.js does it
 * when it initialises); everywhere else a report goes anonymous, which the
 * receiver accepts from Duffloo origins.
 */
let tokenGetter = null;
export const setErrorReportingTokenGetter = getter => {
  tokenGetter = typeof getter === 'function' ? getter : null;
};

const diagnostics = createBrowserDiagnostics({
  clientApp: 'website',
  clientMode: DUFFLOO_MODE,
  release: process.env.GATSBY_DIAGNOSTICS_RELEASE || 'unknown',
  enabled: process.env.NODE_ENV === 'production',
  getEndpoint: () => getBackendBaseUrl().replace(/\/$/, '') + '/client-errors',
  getToken: () => (tokenGetter ? tokenGetter() : null),
});

// The same module is imported during Gatsby SSR, where init is a no-op.
diagnostics.init();
export const initErrorReporting = diagnostics.init;
export const recordHandledError = (error, where, context = {}) => {
  diagnostics.report(error, where, context);
};
